export const Max_Number_Full_Employees = 100;
export const Min_Number_Full_Employees = 1;
export const Max_Time_Percentage_Development = 100;
export const Min_Time_Percentage_Development = 30;
export const Max_Hours_Worked_Yearly = 3000;
export const Min_Hours_Worked_Yearly = 1;
export const Max_Avg_Burden_Cost_Yearly = 300000;
export const Min_Avg_Burden_Cost_Yearly = 1;
export const Justification_APIC = 40;
// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30Databand = '30B9E';
